import { Typography } from '@execonline-inc/execonline-ui';
import clsx from 'clsx';
import { T } from '../../../../../../../Translations';
import { LearningDesign } from '../../Types/SectionTemplates';

interface SectionMetadata {
  programsCount: number;
  schoolPartnersCount: number;
  competenciesCount: number;
}

interface Props {
  section: LearningDesign;
  metadata: SectionMetadata;
  isSelected: boolean;
  onToggleSelection: (id: number) => void;
  onViewDetail: (id: number) => void;
}

const SectionCard: React.FC<Props> = ({
  section,
  metadata,
  isSelected,
  onToggleSelection,
  onViewDetail,
}) => (
  <div
    className={`p-4 border rounded-lg transition-colors cursor-pointer ${
      isSelected ? 'border-primary bg-primary/10' : 'border-border hover:border-muted-foreground'
    }`}
    onClick={() => onViewDetail(section.id)}
    data-intercom-target={`curated-section-card-${section.id}`}
  >
    <div className="flex items-start gap-3">
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => onToggleSelection(section.id)}
        onClick={(e) => e.stopPropagation()}
        className={clsx('h-5 w-5 text-primary rounded-sm cursor-pointer', 'mt-0.5')}
        data-intercom-target={`curated-section-checkbox-${section.id}`}
      />
      <div className="flex-1">
        <Typography variant="bodyMedium" fontWeight="semibold">
          {section.name}
        </Typography>
        <Typography variant="bodySmall" className="mt-1">
          {section.description}
        </Typography>
      </div>
      {/* Counts section - horizontally aligned on the right */}
      <div className="flex items-start">
        <div className="flex flex-col items-center min-w-[80px] pr-4">
          <Typography variant="bodySmall" className="text-muted-foreground">
            <T kind="Programs" />
          </Typography>
          <div className="text-primary font-semibold text-lg">{metadata.programsCount}</div>
        </div>
        <div className="pr-4 text-center text-4xl font-thin text-border">|</div>
        <div className="flex flex-col items-center min-w-[80px] pr-4">
          <Typography variant="bodySmall" className="text-muted-foreground">
            <T kind="School Partners" />
          </Typography>
          <div className="text-primary font-semibold text-lg">{metadata.schoolPartnersCount}</div>
        </div>
        <div className="pr-4 text-center text-4xl font-thin text-border">|</div>
        <div className="flex flex-col items-center min-w-[80px]">
          <Typography variant="bodySmall" className="text-muted-foreground">
            <T kind="Competencies" />
          </Typography>
          <div className="text-primary font-semibold text-lg">{metadata.competenciesCount}</div>
        </div>
      </div>
    </div>
  </div>
);

export default SectionCard;
